import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import { Table, TableCell, TableHeader, TableRow } from '@tiptap/extension-table';
import type { ReportBodyJson } from '../types/weekly-report.js';

/**
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 週次レポート本文（tiptap JSON）を読み取り専用で描画するコンポーネント。編集用 RichTextEditor と同じ拡張集合を使い、表示と編集で見た目を一致させる。HTML 文字列を直接挿入しないため XSS リスクがない。
 * @graph-connects none
 */
export function RichTextContent({ bodyJson }: { bodyJson: ReportBodyJson }) {
  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit.configure({ link: { openOnClick: true } }),
      Image.configure({ inline: false }),
      Table.configure({ resizable: false }),
      TableRow,
      TableHeader,
      TableCell,
    ],
    content: bodyJson,
    editorProps: {
      attributes: { class: 'report-prose max-w-none text-[var(--color-text-primary)]' },
    },
  });

  if (!editor) {
    return null;
  }

  return <EditorContent editor={editor} />;
}
